const COLORS = {
    ICONA_TICKET_APERTI: "#724FCA",
    ICONA_DEALERS: "#A040E9",
    ICONA_SCANNER_ATTIVI: "#FF6A00",

}

export default COLORS;